import ApiClient from './ApiClient';

export const getList = async (companyCode: string):Promise<any> => {
  const params = {};
  const response = await ApiClient.get(`/v1/workingHours/list/${companyCode}`, params);
  return response.data;
};

export const deleteById = async (companyCode: string, workingHoursId: string): Promise<any> => {
  const params = {
    workingHoursId,
  };
  const response = await ApiClient.delete(`/v1/workingHours/${companyCode}`, params);
  return response.data;
};

export default getList;
